'use strict';

/*global services*/

(function ($) {
  $.ajaxK2 = function (url, method, data, successCallBack, errorCallBack) {
    $.ajax({
      url: url,
      type: method,
      data: data,
      success: function (res) {
        if ($.isFunction(successCallBack)) {
          successCallBack(res);
        }
      },

      error: function (xhr, status) {
        if (status === 0) {
          //nepodarilo se navazat spojeni, zrejme nefunguje pripojeni na server
          if (services.has('internet-connection-manager')) {
            services.get('internet-connection-manager').viewOfflineWarning();
          }
        }

        if ($.isFunction(errorCallBack)) {
          errorCallBack(xhr, status);
        }
      }
    });
  };

  $.getK2 = function (url, successCallBack, errorCallBack) {
    $.ajaxK2(url, 'GET', '', successCallBack, errorCallBack);
  };

  $.postK2 = function (url, data, successCallBack, errorCallBack) {
    $.ajaxK2(url, 'POST', data, successCallBack, errorCallBack);
  };
})(jQuery);
